import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';

export const useGetBackOrdered = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['backordered'],
        queryFn: async () => await apiClient.get('product/backordered') as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
